import React, { useEffect, useState } from 'react';
import { getPanelInvoices } from '../../utils/api';
import { PageTitle, Card, Table, Loading, Empty, Grid, StatCard, statusBadge } from '../../components/UI';

export default function ClientInvoices() {
  const [data, setData]       = useState({ stats: {}, invoices: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPanelInvoices()
      .then(r => setData(r.data?.data || {}))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const s = data.stats || {};

  return (
    <div>
      <PageTitle title="🧾 আমার Invoices" sub="সব invoice ও payment history" />

      <Grid cols={4}>
        <StatCard label="Total" value={s.total || 0} color="#a29bfe" />
        <StatCard label="Paid" value={s.paid || 0} color="#55efc4" />
        <StatCard label="Pending" value={s.pending || 0} color="#ffd200" />
        <StatCard label="Due" value={`৳${(s.totalPending || 0).toLocaleString()}`}
          color={s.totalPending > 0 ? '#ff6584' : '#6b6b80'} />
      </Grid>

      <Card>
        {loading ? <Loading /> : (data.invoices || []).length === 0 ? <Empty msg="কোনো invoice নেই" /> : (
          <Table
            headers={['Invoice #', 'বিবরণ', 'পরিমাণ', 'Due Date', 'Status']}
            rows={(data.invoices || []).map((inv, i) => (
              <tr key={i}>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 12, color: '#6b6b80' }}>
                  {inv.invoiceNumber}
                </td>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e' }}>
                  <div style={{ fontSize: 13 }}>
                    {inv.adSpend > 0 && <div>Ad Spend: ৳{inv.adSpend?.toLocaleString()}</div>}
                    {inv.serviceFee > 0 && <div>Service Fee: ৳{inv.serviceFee?.toLocaleString()}</div>}
                    {inv.notes && <div style={{ color: '#6b6b80', fontSize: 12 }}>{inv.notes}</div>}
                  </div>
                </td>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e', fontWeight: 700, color: '#a29bfe', fontSize: 16 }}>
                  ৳{inv.total?.toLocaleString()}
                </td>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 13, color: '#6b6b80' }}>
                  {new Date(inv.dueDate).toLocaleDateString('bn-BD')}
                </td>
                <td style={{ padding: '14px 16px', borderBottom: '1px solid #1e1e2e' }}>
                  {statusBadge(inv.status)}
                </td>
              </tr>
            ))}
          />
        )}
      </Card>

      {s.totalPending > 0 && (
        <Card style={{ background: 'rgba(255,101,132,0.05)', border: '1px solid rgba(255,101,132,0.2)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 24 }}>⚠️</span>
            <div>
              <div style={{ fontWeight: 700, color: '#ff6584' }}>Pending Payment</div>
              <div style={{ fontSize: 13, color: '#6b6b80', marginTop: 4 }}>
                আপনার মোট ৳{s.totalPending?.toLocaleString()} টাকা বাকি আছে। Payment করতে agency তে যোগাযোগ করুন।
              </div>
            </div>
          </div>
        </Card>
      )}
    </div>
  );
}
